import { GridColDef } from "@mui/x-data-grid-pro"
import { FnAxios, FnDialog, I18n, ParseHtml, RouterDOM } from "utilities/utilities";
import { BtnEditOnTableRender, DefaultParamCol } from "../Ticket/components/CreateColumnTable";
import { useEffect, useMemo, useRef, useState } from "react";
import { PaginationInterface, initRows } from 'components/DataGrid';
import { I18NextNs } from "enum/enum";
import moment from "moment";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router";
import { numberFormatterLocale } from "../Ticket/fnTickit";
import _ from "lodash";
import { GetMenuPermissionParamRoute } from "utilities/SystemFunction";

export function useCommitteeTicket() {

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();

    const [nPrmUser, setNPrmUser] = useState(0);
    const [lstStatus, setLstStatus] = useState([]);
    const [userType, setUserType] = useState(0)

    const [isPermission, setIsPermission] = useState<boolean>(false);
    const [loadingTable, setLoadingTable] = useState(false);
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "sUpdate",
        sSortDirection: "desc",
    });


    //#region Form
    const formSearch = useForm({
        shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
    });
    // #endregion

    useEffect(() => {
        GetMenuPermissionParamRoute("/CommitteeTicketList", AxiosFn, setIsPermission, DialogFn);
    }, []);

    useEffect(() => {
        getStatusById();
        getCheckEmpMuseum();
        getTable(dataRow);
    }, [])

    const getCheckEmpMuseum = () => {
        DialogFn.BlockUI();
        AxiosFn.Get(`Ticket/GetCheckEmpMuseum`, { nMenuId: 20 }, (result) => {
            DialogFn.UnBlockUI();
            let objResult = result.objResult;
            setNPrmUser(objResult.nPrmUser)
            setUserType(objResult.nUserTypeID)
        });
    };

    const getStatusById = () => {
        DialogFn.BlockUI();
        AxiosFn.Get(`Ticket/GetStatusById`, { sMode: "S", sStatusId: "1,2,5" }, (result) => {
            DialogFn.UnBlockUI();
            let objResult = result.objResult;
            setLstStatus(objResult.lstStatus)
        });
    };


    const getTable = (p: PaginationInterface) => {
        DialogFn.BlockUI();
        setLoadingTable(true);
        let Param = {
            ...p,
            arrRows: [],
            sType: "commitee",
            nStartDate: formSearch.getValues("nStartDate") ? formSearch.getValues("nStartDate").valueOf() : null,
            nEndDate: formSearch.getValues("nEndDate") ? formSearch.getValues("nEndDate").valueOf() : null,
            arrMuseumId: formSearch.getValues("arrMuseum") ?? [],
            arrStatusId: formSearch.getValues("arrStatusId") ?? [],
        };
        AxiosFn.Post(`SoldTicket/GetTableSoldCommitteeTicket`, Param, (result) => {
            setLoadingTable(false);
            DialogFn.UnBlockUI();
            let objResult = result.objResult;
            setDataRow({
                ...p,
                arrRows: objResult.lstData,
                nDataLength: objResult.nDataLength,
                nPageIndex: objResult.nPageIndex,
            });
        });
    };
    const onDelete = (arrSelect) => {
        DialogFn.Submit(I18n.SetText("Message.ConfirmDelete", I18NextNs.labelComponent), () => {
            DialogFn.BlockUI();
            setLoadingTable(true);
            AxiosFn.Post(`SoldTicket/OnDeleteTableSoldTicket`, { lstId: arrSelect }, () => {
                getTable(dataRow)
                DialogFn.Success(I18n.SetText("Message.DeleteComplete", I18NextNs.labelComponent));
                DialogFn.UnBlockUI();
            });
        });
    }

    const handleClearSearch = () => {
        Object.keys(formSearch.getValues()).forEach((key => {
            formSearch.setValue(key, null);
            formSearch.clearErrors(key);
        }))
        getTable(dataRow);
    };



    const dataColumn: GridColDef[] = [
        {
            ...DefaultParamCol,
            field: "cAction",
            width: 60,
            minWidth: 60,
            headerName: "",
            type: "actions",
            sortable: false,
            flex: 0,
            renderCell: (params) => {
                return (
                    <BtnEditOnTableRender
                        path={"/CommitteeTicketForm"}
                        params={params}
                        nPermision={isPermission ? params.row.isView ? 1 : 2 : 1}
                    />
                );
            },
        },
        {
            ...DefaultParamCol,
            field: "sDateSold",
            headerName: `${I18n.SetText("Ticket.DateSold")}`,
        },
        {
            ...DefaultParamCol,
            field: "nAmountMoney",
            headerName: `${I18n.SetText("Ticket.TotalMoney")}`,
            align: "right",
            flex: 1,
            renderCell: (params) => {
                return (
                    <>
                        {numberFormatterLocale(params.value, 2)}
                    </>
                );
            },
        },
        {
            ...DefaultParamCol,
            field: "sSellName",
            headerName: `${I18n.SetText("Ticket.NameSold")}`,
            align: "left",
            flex: 2,
            renderCell: (params) => {
                return (
                    <>
                        {ParseHtml(params.value)}
                    </>
                );
            },
        },
        {
            ...DefaultParamCol,
            field: "sUpdateName",
            headerName: `${I18n.SetText("Ticket.NameSaver")}`,
            align: "left",
            flex: 2,
        },
        {
            ...DefaultParamCol,
            field: "sUpdate",
            headerName: `${I18n.SetText("Ticket.DateSave")}`,
        },
        {
            ...DefaultParamCol,
            field: "sStatusName",
            headerName: `${I18n.SetText("Ticket.Status")}`,
            flex: 1.5,
        },
    ];

    return {
        dataColumn,
        getTable,
        onDelete,
        dataRow,
        loadingTable,
        formSearch,
        lstStatus,
        handleClearSearch
    };
}


export function useCommitteeTicketForm() {

    //#region Hook
    const Router = RouterDOM();
    const AxiosFn = FnAxios()
    const DialogFn = FnDialog();
    const location = useLocation();
    // #endregion
    const onClearAttachFile = useRef(null);

    const objParamPath = useMemo(() => {
        const ParamId = new URLSearchParams(location.search).get("strParam");
        const ParamPrs = 2;
        return { ParamId, ParamPrs }
    }, [location.search])

    //#region State / Usememo
    const [isPermission, setIsPermission] = useState<boolean>(false);
    const [lstTotalTicketSell, setLstTotalTicketSell] = useState([])
    const [isView, setIsView] = useState(true)
    const [isCommitteeMuseum, setIsCommitteeMuseum] = useState(false)
    const [statusID, setStatusID] = useState(0)
    const [arrAttachmentList, setArrAttachmentList] = useState([])
    const [objMuseum, setObjMuseum] = useState({
        nMuseumID: null,
        sMuseumName: null,
    })
    const [option, setOption] = useState({
        lstMuseum: [],
        lstSeller: [],
        lstCurrencyNotes: [],
        lstCurrencyCoins: [],
        lstEmpFund: [],
        lstEmpMoney: [],
        lstTicketTypeNotFree: [],
    })
    const [defaultValues, setDefaultValues] = useState({
        dSoldTicket: null,
        nMuseumID: null,
        sMuseum: null,
        arrSeller: null,
        nEmpFund: null,
        nEmpMoney: null,
        lstSoldTicket: [],
        lstReturnTicket: [],
        lstCompareTicket: [],
        lstCurrencyNotes: [],
        lstCurrencyCoins: [],
        lstCurrencyElec: [],
        sRemark: null,
        sApprove: null,
    })

    // #endregion

    //#region Form
    const form = useForm({
        shouldFocusError: true,
        shouldUnregister: false,
        mode: "all",
        defaultValues: defaultValues,
    });
    // const { formState: { errors } } = useForm();

    // #endregion

    const { reset } = form;


    useEffect(() => {
        GetMenuPermissionParamRoute("/CommitteeTicketList", AxiosFn, setIsPermission, DialogFn);
        getOptionInitialData()
    }, [])

    const gotoBack = () => {
        Router.GoToPage("/CommitteeTicketList")
    }

    const OnEditCommitTicketSold = () => {
        const objParam = {
            sIDTicketSold: objParamPath.ParamId,
        };
        DialogFn.Submit(I18n.SetText("Message.ConfirmChange", I18NextNs.labelComponent), () => {
            AxiosFn.Post(`SoldTicket/OnEditCommittee`, objParam, () => {
                DialogFn.Success(I18n.SetText("Message.SaveComplete", I18NextNs.labelComponent), () => {
                    window.scrollTo(0, 0);
                    window.location.reload();
                });
            });
        });
    }

    const OnCheckRejectTicketSold = async (objParam) => {
        let isHasReStatus = false;
        let messageFail = false;
        DialogFn.BlockUI();
        await AxiosFn.Post(`SoldTicket/OnCheckRejectTicketSold`, objParam, (result) => {
            DialogFn.UnBlockUI();
            let objResult = result.objResult;
            isHasReStatus = objResult.isHasReStatus
            messageFail = objResult.sMessage
        }, () => { DialogFn.UnBlockUI(); });
        return { isHasReStatus, messageFail };
    }

    const handleSubmitForm = async () => {
        form.clearErrors()
        if (form.getValues("sApprove") === "A" && arrAttachmentList.length === 0) {
            DialogFn.Warning("กรุณาระบุไฟล์")
            return;
        }
        else if (form.getValues("sApprove") === "R") {
            const param = {
                sTicketSoldID: objParamPath.ParamId,
                sRemark: form.getValues("sRemark"),
            }
            let { isHasReStatus, messageFail } = await OnCheckRejectTicketSold(param);
            if (isHasReStatus) {
                let sMessage = "SecretWordYesNo" + messageFail
                DialogFn.SubmitWarning(sMessage, () => {
                    DialogFn.CloseSubmitWarning();
                    OnSubmitTicketCommittee(true);
                }, () => {
                    DialogFn.CloseSubmitWarning();
                    OnSubmitTicketCommittee(false);
                })
                return;
            }
        }

        OnSubmitTicketCommittee(false)
    }

    const OnSubmitTicketCommittee = (isHasReStatus: boolean) => {
        let objParam = {
            sMode: form.getValues("sApprove"),
            sIDTicketSold: objParamPath.ParamId,
            nEmpFund: form.getValues("nEmpFund"),
            nEmpMoney: form.getValues("nEmpMoney"),
            sRemark: form.getValues("sRemark"),
            lstFile: arrAttachmentList,
            isHasReStatus: isHasReStatus,
        };
        DialogFn.Submit(I18n.SetText("Message.ConfirmSave", I18NextNs.labelComponent), () => {
            AxiosFn.Post(`SoldTicket/OnSubmitTicketCommittee`, objParam, () => {
                DialogFn.Success(I18n.SetText("Message.SaveComplete", I18NextNs.labelComponent), () => {
                    gotoBack();
                });
            });
        });
    }


    const getOptionInitialData = () => {
        if (!objParamPath.ParamId) {
            return;
        }
        DialogFn.BlockUI();
        AxiosFn.Get(`SoldTicket/GetFormInfoSoldTicket`, { sSoldTicketID: objParamPath.ParamId }, (result) => {
            DialogFn.UnBlockUI();
            let objResult = result.objResult;
            if (objResult) {
                // setIsView([5].includes(objResult.sMode))
                setStatusID(parseInt(objResult.sMode))
                setIsCommitteeMuseum(objResult.isCommitteeMuseum)
                // setIsView(!([0,3].includes(objResult.sMode) && objResult.isCreate))
                setObjMuseum({
                    nMuseumID: parseInt(objResult.objSold.sIDMuseum),
                    sMuseumName: objResult.objSold.sMuseum,
                })

                setOption(option => ({
                    ...option,
                    lstMuseum: objResult.lstMuseum,
                    lstEmpFund: objResult.lstEmpFund,
                    lstEmpMoney: objResult.lstEmpMoney,
                    lstSeller: objResult.lstSellerOption,
                    lstCurrencyNotes: objResult.objSold.lstCurrencyNotes,
                    lstCurrencyCoins: objResult.objSold.lstCurrencyCoins,
                    lstTicketTypeNotFree: objResult.lstTicketTypeNotFree,
                }))

                let deepCopy = _.cloneDeep(objResult.objSold.lstSoldTicket);
                setLstTotalTicketSell(deepCopy)

                let objNew = {
                    nMuseumID: parseInt(objResult.objSold.sIDMuseum),
                    sMuseum: objResult.objSold.sMuseum,
                    dSoldTicket: moment(objResult.objSold.nSold),
                    arrSeller: objResult.objSold.arrSeller,
                    nEmpFund: objResult.objSold.nEmpFund,
                    nEmpMoney: objResult.objSold.nEmpMoney,
                    lstSoldTicket: objResult.objSold.lstSoldTicket,
                    lstReturnTicket: objResult.objSold.lstReturnTicket,
                    lstCompareTicket: objResult.objSold.lstCompareTicket,
                    lstCurrencyNotes: objResult.objSold.lstCurrencyNotes,
                    lstCurrencyCoins: objResult.objSold.lstCurrencyCoins,
                    lstCurrencyElec: objResult.objSold.lstCurrencyElec,
                    sApprove: objResult.objSold.sAppreve,
                }

                setArrAttachmentList(objResult.lstFile)

                setDefaultValues(defaultValues => ({
                    ...defaultValues,
                    ...objNew
                }))

                reset({
                    ...objNew,
                });
            }
        });
    };

    const ExportPDF = async () => {
        form.trigger("nEmpFund");
        form.trigger("nEmpMoney");

        if (form.getValues("nEmpFund") && form.getValues("nEmpMoney")) {
            DialogFn.BlockUI();
            let param = {
                sKeyID: objParamPath.ParamId,
                nEmpFund: form.getValues("nEmpFund"),
                nEmpMoney: form.getValues("nEmpMoney"),
            }

            let fileName = `เอกสารเพื่อลงนาม_${moment().format('yyyyMMDDHHmmss')}.pdf`;
            await AxiosFn.DowloadFileBlob("Ticket/ExportPDF", param, fileName, () => {
                DialogFn.UnBlockUI()

            }, () => { DialogFn.UnBlockUI() })
        }
    }


    return {
        isPermission,
        statusID,
        isCommitteeMuseum,
        isView,
        form,
        gotoBack,
        handleSubmitForm,
        objMuseum,
        option,
        defaultValues,
        arrAttachmentList,
        setArrAttachmentList,
        onClearAttachFile,
        ExportPDF,
        lstTotalTicketSell,
        setLstTotalTicketSell,
        OnEditCommitTicketSold
    }

}